import { environment } from '../../../environment/environement.js';

const ENV_PATH = environment.isStaticCloud() ? '/_origin/dxgw/_call' : '';

export const REFI_LIENHOLDER_CONST = {
  get LIENHOLDER_BFF_URL() {
    return `${ENV_PATH}/protected/942615/applications/`;
  },
  get HOST_BFF_URL() {
    return `${ENV_PATH}/protected/831647/host-app/bff`;
  },
  GET_FEATURE_TOGGLE_URL: featureKey => `${ENV_PATH}/protected/942615/features/${featureKey}`,
  FEATURE_TOGGLES: {
    LIENHOLDER_FEATURE_TOGGLE: '', // update when feature is available for LH
  },
  ASSETS_URL: `${new URL(import.meta.url)?.origin}/assets`,
  BASE_APPLICATION_URL: `${ENV_PATH}/protected/942615/applications/`,
  HTTP_HEADERS: {
    Accept: 'application/json;v=2',
    'Content-Type': 'application/json;v=2',
    Cookie: '',
  },
  C1_REFI_APPIDS: 'C1-REFI-APPIDS',
  REFI_SESSION_KEY: 'auto-refi-session',
  API_ERR_MSG: 'Our system experienced an error. Please try again later. For help right now, you can call us at 1-888-263-4582.',
  CHECKOUT_API_ERR_MSG: 'Our system experienced an error. Please try again in a few minutes.',
  HASHTAG: '#',
  get isLocalEnv() {
    return window.location.hostname === 'localhost';
  },
  get isSBEnv() {
    return ['refi-web-ui-sb.clouddqt.capitalone.com', 'coaf-lienholder-mfe-sb.clouddqtext.capitalone.com', 'auto-refi-sb.clouddqt.capitalone.com'].includes(window.location.hostname);
  },
  get isDevEnv() {
    return ['refi-web-ui-dev.clouddqt.capitalone.com', 'coaf-lienholder-mfe-dev.clouddqtext.capitalone.com', 'auto-refi-dev.clouddqt.capitalone.com'].includes(window.location.hostname);
  },
  UI_VARIANT: {
    compareToOldLoan: 'COMPARE_TO_OLD_LOAN',
  },
  REFI_CI_KEY: 'refi-ci',
  ROUTE_CHANGE: 'mfe-internal-route-change',
  ROUTE_CHANGE_EVENT: new CustomEvent('mfe-internal-route-change'),
  EXP_FEEDBACK_EVENT: (experimentName, feedback) =>
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'experiment-feedback',
        data: {
          experimentName,
          feedback,
        },
      },
    }),
  MARKETING_ATTRIBUTE_COOKIE: 'afw3', // set in persist-marketing-attributes
  EXP_INIT_EVENT: experimentName => this.EXP_FEEDBACK_EVENT(experimentName, { feedbackEvent: 'Initialized' }),
  EXP_SUCCESS_EVENT: (experimentName, rewardValue = 1) =>
    this.EXP_FEEDBACK_EVENT(experimentName, {
      feedbackEvent: 'Success',
      rewardValue,
    }),
  TIMEOUT_IN_MS: 10000,
};
